module.exports = __webpack_public_path__ + "img/gb-whatsapp-for-pc.05e25aae.webp";